// extracted by mini-css-extract-plugin
export default {"container":"TO-z","topReviewHeading":"UO-z","criticalReview":"VO-z","favorableReview":"WO-z","vsSeparator":"XO-z"};